import React, { Component } from 'react'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Skeleton from 'react-loading-skeleton'

class SkeletonTable extends Component {
  render () {
    const { rows, cols } = this.props
    if (!rows || !cols) return null
    return this.skeleton(rows, cols)
  }

  skeleton (rows, cols) {
    var skeleton = []
    for (var i = 0; i < rows; i++) {
      skeleton.push(this.skeletonRow(cols, i))
    }
    return skeleton
  }

  skeletonRow (cols, i) {
    var cells = []
    for (var k = 0; k < cols; k++) {
      cells.push(this.skeletonCell(k))
    }
    return (
      <TableRow key={i}>
        {cells}
      </TableRow>
    )
  }

  skeletonCell (k) {
    return (
      <TableCell key={k}>
        <Skeleton count={1} />
      </TableCell>
    )
  }
}

export default SkeletonTable



// WEBPACK FOOTER //
// ./src/common/skeleton-table.js